import React, {useState, useEffect} from 'react'
import { motion } from 'framer-motion'
import './Abouts.scss'
import { images } from '../../constants'
import { urlFor, client } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'

const Abouts = () => {
  const [abouts, setAbouts] = useState([])

  useEffect(() => {
    try {
      const query = '*[_type == "abouts"]'
    client.fetch(query)
    .then((data)=>{setAbouts(data)})
    
    } catch (error) {
      console.log(error)  
    }
  }, [])
  
  return (
    
    <div>
      <h2 className='head-text'>
        I know that <span>Good Development</span>
        <br/> means <span>Good Business</span>
      </h2>

      <div className="app__profiles">
      {abouts.map((data, key)=>(
        <motion.div 
        whileInView={{opacity: 1}}
        whileHover={{scale: 1.1}}
        transition={{duration:0.5, type: 'tween'}}
        className="app__profile-item"
        key={data.title+key}
        >
          <img src={urlFor(data.imgUrl)}  alt={data.title}/>
          <h2 className="bold-text" style={{marginTop:20}} > {data.title}</h2>
          <p className="p-text" style={{marginTop:10}} > {data.description}</p>
          
        </motion.div>
      ))}
      </div>
    </div>
  )
}

export default AppWrap(MotionWrap(Abouts,'app__about'), 'about', 'app__whitebg')